import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { PatientD } from 'src/app/models/Pdetails';
import { AllPatient } from 'src/app/models/patient';
import { ExcelService } from "src/app/service/excelDownload/excel.service";

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-superadmin-patients',
  templateUrl: './superadmin-patients.component.html',
  styleUrls: ['./superadmin-patients.component.css']
})
export class SuperadminPatientsComponent implements OnInit {

  constructor(
    private excelService: ExcelService,
    private _formBuilder: UntypedFormBuilder, private service: VproService, private spinner: NgxSpinnerService, private utils: Utils
  ) { }
  patientForm: UntypedFormGroup;
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  patients: AllPatient[];
  noPatient: boolean = false;
  ngOnInit() {
    this.patientForm = this._formBuilder.group({
      pat_name: [''],
      email_id: ['', [Validators.maxLength(50),
      Validators.pattern(Utils.emailpat),]]
    });
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  findPatient(pg: number = 1) {
    let data = {
      //type: "superadmin",
    };

    if (pg) {
      this.page = pg;
    }

    if (this.patientForm.value.pat_name) {
      //data['pid'] = this.patientForm.value.pat_id;
      data['name'] = this.patientForm.value.pat_name;
    }

    if (this.patientForm.value.email_id) {
      data['email_id'] = this.patientForm.value.email_id;
    }

    this.spinner.show();
    this.service.fetchAllPatients(data, `?page=${this.page}&limit=${this.pagesize}`).subscribe(
      (res) => {
        this.spinner.hide();

        this.patients = [...res['result']];
        this.collectionSize = res['totalCount'];
        if (this.collectionSize == 0)
          this.noPatient = true;
      }, (error) => {
        this.spinner.hide();
        console.log(error);
        let message = "Something wrong. Couldn't complete request.";
        this.showToast('error', message);
        return;
      });
  }

  pageChanged() {
    this.findPatient(this.page)
  }

  onAccStatusChange = async (index, enable) => {
    let data = new AllPatient();
    data.pid = this.patients[index].pid;
    data.patient_status = !enable;
    this.updatePatientStatus(data);
  }

  updatePatientStatus(data) {
    //data['type'] = "superadmin";
    this.spinner.show();
    this.service.updatePatient(data.pid, data).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        this.showToast('success', "Patient profile has been updated successfuly");
        this.findPatient(this.page);
      },
      (error) => {
        this.spinner.hide();
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update profile."
        this.showToast('error', message);
      }
    );
  }


  exportAsXLSX() {
    let patientData;
    let collectionSize
    let data = {
      //type: "superadmin",
    };

    //call Api without pagination 
    this.spinner.show();
    this.service.fetchAllPatients(data).subscribe(
      (res) => {
        this.spinner.hide();
        patientData = res;
        //excel data
        let excelPhy: any = [];
    let excelFileName: string = "";
    let excelSheetName: string = "";
    let personalInfo: any = [];

    if (patientData) {
      excelFileName = "_Patients";
      excelSheetName = "Patients";
    }
    /* Include physician Information in excel sheet */
    if (patientData && patientData.length > 0) {
      patientData.forEach(element => {
        excelPhy.push({
        "NAME":  ((element.first_name === null ? "" : element.first_name) + " " + (element.last_name === null ? "" : element.last_name)),
        "ID": element.pid === null ? "Not Available" : element.pid,
        "EMAIL_ID": element.email_id === null ? "Not Available" : element.email_id, 
        "ACTIVE ACCOUNT": element.patient_status  === null ? "Not Available" : element.patient_status,
    });
      });
      this.excelService.exportAsExcelFile(personalInfo, excelPhy, excelFileName, excelSheetName);
    }
      }, (error) => {
        this.spinner.hide();
        console.log(error);
        let message = "Something wrong. Couldn't complete request.";
        this.showToast('error', message);
        return;
      });


  }


}
